import React from "react";
import { useNavigate } from "react-router-dom";
import "./Collection.css";

// Country / Currency Context
import { useCountry } from "./CountryContext";

import trending1 from "../Images/green1.jpg";
import trending2 from "../Images/image33.png";
import trending3 from "../Images/grey1.jpg";

import summer1 from "../Images/newcollection4.jpg";
import summer2 from "../Images/image30.png";
import summer3 from "../Images/south10.jpeg";

import winter1 from "../Images/image31.png";
import winter2 from "../Images/orange11.jpg";


const Collection = () => {

  const navigate = useNavigate();

  const { formatPrice } = useCountry();


  // =========================
  // WOMEN'S PRODUCT CLICK
  // =========================

  const handleProductClick = (id) => {
    navigate(`/womens/${id}`);
  };


  // =========================
  // VIEW ALL BUTTON
  // =========================

  const handleViewAll = () => {
    navigate("/view-all");
  };


  return (
    <section className="newCollection-section">

      <div className="newCollection-container">


        {/* =========================
            TRENDING COLLECTION
        ========================== */}

        <div className="newCollection-heading">

          <h2>
            Trending Collections
          </h2>

          <p>
            See what's trending now
          </p>

        </div>


        <div className="newCollection-cards">


          {/* TRENDING PRODUCT 1 */}

          <div
            className="newCollection-card"
            onClick={() => handleProductClick(201)}
            role="button"
            tabIndex="0"
          >

            <img
              src={trending1}
              alt="African Women's Green Dress"
            />

            <h4>
              Women dresses
            </h4>

            <span>
              From {formatPrice(599)}
            </span>

          </div>


          {/* TRENDING PRODUCT 2 */}

          <div
            className="newCollection-card"
            onClick={() => handleProductClick(202)}
            role="button"
            tabIndex="0"
          >

            <img
              src={trending2}
              alt="African Women's Print Dress"
            />

            <h4>
              Women dresses
            </h4>

            <span>
              From {formatPrice(899)}
            </span>

          </div>


          {/* TRENDING PRODUCT 3 */}

          <div
            className="newCollection-card"
            onClick={() => handleProductClick(203)}
            role="button"
            tabIndex="0"
          >

            <img
              src={trending3}
              alt="African Women's Grey Dress"
            />

            <h4>
              Women dresses
            </h4>

            <span>
              From {formatPrice(799)}
            </span>

          </div>

        </div>


        {/* =========================
            VIEW ALL BUTTON
        ========================== */}

        <div className="newCollection-btn-box">

          <button
            type="button"
            className="newCollection-btn"
            onClick={handleViewAll}
          >
            View All →
          </button>

        </div>


        {/* =========================
            SUMMER COLLECTION
        ========================== */}

        <div className="newCollection-grid">


          {/* LEFT */}

          <div className="newCollection-left">

            <h2>
              Summer Collections
            </h2>

            <p>
              Discover fresh and stylish summer outfits designed
              for comfort and elegance.
            </p>


            {/* SUMMER PRODUCT 4 */}

            <img
              src={summer1}
              alt="Summer African Women's Dress"
              className="newCollection-large-img"
              onClick={() => handleProductClick(204)}
            />

          </div>


          {/* RIGHT */}

          <div className="newCollection-right">

            <p>
              We provide the latest fashion collections for every
              season with trendy designs and premium quality.
            </p>


            <div className="newCollection-image-group">


              {/* SUMMER PRODUCT 5 */}

              <img
                src={summer2}
                alt="Summer African Women's Dress"
                className="newCollection-small-img"
                onClick={() => handleProductClick(205)}
              />


              {/* SUMMER PRODUCT 6 */}

              <img
                src={summer3}
                alt="Summer African Women's Dress"
                className="newCollection-large-img"
                onClick={() => handleProductClick(206)}
              />

            </div>


            <button
              type="button"
              className="newCollection-btn"
              onClick={handleViewAll}
            >
              Explore →
            </button>

          </div>

        </div>


        {/* =========================
            WINTER COLLECTION
        ========================== */}

        <div className="newCollection-grid reverse">


          {/* LEFT */}

          <div className="newCollection-left">

            <p>
              Explore stylish winter fashion with warm and elegant
              designs for modern women.
            </p>


            <div className="newCollection-image-group">


              {/* WINTER PRODUCT 7 */}

              <img
                src={winter1}
                alt="Winter African Women's Dress"
                className="newCollection-large-img"
                onClick={() => handleProductClick(207)}
              />


              {/* WINTER PRODUCT 8 */}

              <img
                src={winter2}
                alt="Winter African Women's Dress"
                className="newCollection-small-img"
                onClick={() => handleProductClick(208)}
              />

            </div>

          </div>


          {/* RIGHT */}

          <div className="newCollection-right">

            <h2>
              Winter Collections
            </h2>

            <p>
              Stay warm and fashionable with our exclusive winter
              collection crafted with premium quality fabrics.
            </p>


            <button
              type="button"
              className="newCollection-btn"
              onClick={handleViewAll}
            >
              Explore →
            </button>

          </div>

        </div>

      </div>

    </section>
  );
};


export default Collection;